export default "/images/vendor/flag-icons/flags/1x1/ar.svg?658e0f364fc6cec6b1737d33696f34ec";